<template>
  <el-select
    v-model="locationsModel"
    :clearable="!optionsValueIsSet"
    :disabled="disabled"
    :loading="loading"
    :multiple="true"
    :placeholder="placeholder ?? $t('COMMON.LOCATION')"
    :popper-class="popperClass"
    :remote-method="getLocations"
    :remote="!optionsValueIsSet"
    @change="locationsChanged"
    autocomplete="new-password"
    collapse-tags
    filterable
  >
    <slot>
      <span class="first-choose" v-if="showLabel">
        <span class="first-choose-label">{{ $t("COMMON.LOCATION") }}</span>
      </span>
    </slot>
    <el-option
      v-for="location in locationsList"
      :key="location.id"
      :value="location.id"
      :label="`${location.name}`"
      :disabled="!selectable(location)"
      class="location-option"
    >
      <span
        :class="{ 'text-light': !selectable(location) }"
        class="mr-2 label"
        style="float: left"
      >
        {{ location.name }}
      </span>
      <span
        class="ml-auto"
        style="float: right; color: #8492a6; font-size: 13px"
        :class="{ 'text-light': !selectable(location) }"
        
      >
        {{ location.organization?.name }}
      </span>
    </el-option>
  </el-select>
</template>

<script>
import { difference } from "lodash";
import { Option, Select } from "element-ui";

export default {
  name: "locations-selector",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
  },

  props: {
    placeholder: {
      type: String,
      default: null,
      description: "Placeholder of input",
    },
    disabled: {
      type: Boolean,
      default: false,
      description: "Disable the input",
    },
    locations: {
      type: Array,
      default: () => [],
      description: "Locations",
    },
    organization: {
      type: String,
      default: null,
      description: "Organization id",
    },
    showLabel: {
      type: Boolean,
      default: false,
    },
    popperClass: {
      type: String,
      default: null,
    },
  },

  data() {
    const locationsModel = this.locations?.map((item) => item.id) ?? [];
    return {
      locationsModel,
      locationsList: {},
      loading: false,
      firstLocationSelectedOrganizationId: null,
    };
  },

  setup() {},

  created() {
    this.getLocations(null, this.locations);
  },

  computed: {
    optionsValueIsSet() {
      return !!this.optionsValue && Array.isArray(this.optionsValue);
    },

    // firstLocationSelectedOrganizationId() {
    //   return this.locationsList[this.locationsModel[0] ?? null]?.organization
    //     ?.id;
    // },
  },

  methods: {
    async getLocations(query = null, locations = null) {
      if (this.optionsValueIsSet) {
        this.loadOptions(this.optionsValue);
        return;
      }

      try {
        this.loading = true;
        let params = {
          sort: "-updated_at",
          filter: {
            ...(query ? { search: query } : {}),
            ...(locations
              ? { with_ids: locations.map((item) => item.id) }
              : {}),
          },
          page: {
            number: 1,
            size: 10,
          },
          include: "organization",
          fields: {
            organizations: "name",
          },
        };
        if (this.organization) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              organization: this.organization,
            },
          };
        }
        await this.$store.dispatch("locations/list", params);
        const locationsArr = await this.$store.getters["locations/list"];
        this.loadOptions(locationsArr);
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    selectable(location) {
      return (
        !this.firstLocationSelectedOrganizationId ||
        this.firstLocationSelectedOrganizationId == location.organization?.id
      );
    },

    loadOptions(optionsArr) {
      this.locationsList = {};
      optionsArr.forEach((location) => {
        this.locationsList[location.id] = location;
      });

      // if (this.defaultFirstOption && !this.locationModel && !this.disabled) {
      //   this.locationModel = optionsArr[0]?.id ?? null;

      //   this.$nextTick(() => {
      //     this.locationChanged(this.locationModel);
      //   });
      // }
    },

    async locationsChanged(locations) {
      this.firstLocationSelectedOrganizationId =
        this.locationsList[this.locationsModel[0] ?? null]?.organization?.id;

      const LocationsData = Object.values(this.locationsList).filter(
        (location) => locations.includes(location.id)
      );

      this.$emit(
        "locationsChanged",
        locations,
        LocationsData
        // [...locations].map((item) => ({ type: "locations", id: item }))
      );
    },
  },

  watch: {
    locations(locations) {
      if (locations && locations.length != 0) {
        const locationsData = locations.map((item) => item.id);
        if (difference(locationsData, this.locationsModel).length !== 0) {
          this.locationsModel = locationsData;
          this.getLocations(null, locations);
        }
      } else {
        this.locationsModel = [];
      }
    },
    organization() {
      this.getLocations();
    },
  },
};
</script>

<style lang="scss">
.el-select-dropdown.is-multiple .el-select-dropdown__item.selected {
  .label {
    font-weight: bold;
  }
}
.el-select-dropdown.is-multiple .location-option.el-select-dropdown__item.selected{
  padding-left: 25px;
}

.el-select-dropdown.is-multiple .location-option.el-select-dropdown__item.selected::after {
  left: 10px;
  color: #409eff;
  // content: '';
  // background: #409eff;
  // width: 12px;
  // height: 12px;
  // border-radius: 3px;
  // font-size: 10px;
}
.el-select .el-tag {
  max-width: calc(100% - 30px);
  .el-select__tags-text {
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
